import { render, staticRenderFns } from "./taskdetailright.vue?vue&type=template&id=1bbf878e"
import script from "./taskdetailright.vue?vue&type=script&lang=js"
export * from "./taskdetailright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports